module.exports = __webpack_public_path__ + "static/media/15.637a3947.jpg";